/**
 * 导入工具类
 */
import { isAndroid, isIOS } from '../utils/index';

/**
 * 初始化webview bidge
 * @param callback
 */
function setupWebViewJavascriptBridge(callback: BridgeCallback): void {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge);
  }

  /**
   * 安卓系统
   */
  if (isAndroid()) {
    document.addEventListener(
      'WebViewJavascriptBridgeReady',
      function () {
        callback(window.WebViewJavascriptBridge);
      },
      false,
    );
  }

  /**
   * iOS系统
   */
  if (isIOS()) {
    if (window.WVJBCallbacks) {
      window.WVJBCallbacks.push(callback);
    } else {
      window.WVJBCallbacks = [callback];
    }
    const iframeId = 'WVJBIframe_Reconnect';
    if (!document.getElementById(iframeId)) {
      const WVJBIframe: HTMLIFrameElement = document.createElement('iframe');
      WVJBIframe.id = iframeId;
      WVJBIframe.style.display = 'none';
      WVJBIframe.src = 'https://__bridge_loaded__';
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(() => {
        document.documentElement.removeChild(WVJBIframe);
      }, 100);
    }
  }
}

/**
 * 触发handler
 * @param name
 * @param data
 * @param callback
 */
function bridgeCallHandler(name: string, data: string, callback: BridgeResponseCallback | null): void {
  setupWebViewJavascriptBridge((bridge: WebViewBridge) => {
    bridge.callHandler(name, data, (res: string) => {
      if (callback) {
        callback(res);
      }
    });
  });
}

/**
 * 注册handler
 * @param name
 * @param data
 * @param callback
 */
function bridgeRegisterHandler(name: string, data: string, callback: BridgeResponseCallback | null): void {
  setupWebViewJavascriptBridge((bridge: WebViewBridge) => {
    bridge.registerHandler(name, (res: string, responseCallback: BridgeResponseCallback) => {
      if (callback) {
        callback(res);
      }
      responseCallback(data);
    });
  });
}

/**
 * 导出初始化方法
 */
export { setupWebViewJavascriptBridge, bridgeCallHandler, bridgeRegisterHandler };
